import { getStoredAuthProfile, getStoredToken } from "./auth";
import { normalizeSchoolCode } from "./userNormalization";

export const buildCanonicalAuthHeaders = (baseHeaders = {}, context = {}) => {
  const headers = new Headers(baseHeaders);
  const profile = context.profile || getStoredAuthProfile();
  const token = String(context.token ?? getStoredToken()).trim();
  const schoolCode = String(context.schoolCode || normalizeSchoolCode(profile)).trim();

  headers.delete("x-auth-token");
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (schoolCode) headers.set("x-school-code", schoolCode);
  return headers;
};

export const authenticatedFetch = (input, init = {}, context = {}) =>
  fetch(input, { ...init, headers: buildCanonicalAuthHeaderObject(init.headers, context) });

export const buildCanonicalAuthHeaderObject = (baseHeaders = {}, context = {}) =>
  Object.fromEntries(
    Array.from(buildCanonicalAuthHeaders(baseHeaders, context).entries()).map(([key, value]) => [
      key.toLowerCase() === "authorization" ? "Authorization" :
        key.toLowerCase() === "content-type" ? "Content-Type" :
          key.toLowerCase() === "idempotency-key" ? "Idempotency-Key" : key,
      value,
    ]),
  );
